import React, { Component } from 'react'
import '../../styles/css/SideMenu.css'
import '../../styles/css/AdminMain.css'
import '../../styles/css/TopBar.css'
import logoImage from '../../styles/images/sqwad_logo.png';
import ExperienceScopeBar from './ExperienceScopeBar';

// On a multi-tenant admin the most useful thing the top bar can say is
// which tenant you are about to change. Every .env file already sets
// REACT_APP_CLEAN_CLIENT_NAME (Dev / Checkers / Winterhawks / CV Firebirds).
const tenantName =
    process.env.REACT_APP_CLEAN_CLIENT_NAME ||
    process.env.REACT_APP_FIREBASE_PROJECT_ID ||
    'SQWAD';

class TopBar extends Component {
    render() {
        return (
          <div className="admin-topbar">
            <div className="admin-topbar-club">
              <img src={logoImage} alt="" />
              <span className="topBarText">{tenantName}</span>
            </div>
            {/* Renders nothing unless this tenant has experiences turned on and
                more than one to choose between. */}
            <ExperienceScopeBar/>
          </div>
        );
    }
}

export default TopBar
